export default "__VITE_ASSET__B7zTFZl3__"